import { z } from 'zod';
import { makeEvent } from './EventBase';
import { OfferLetter } from '../client';

export const OfferLetterSaved = makeEvent(
    'OfferLetterSaved',
    z.object({
        data: OfferLetter,
    }),
);

export type OfferLetterSaved = (typeof OfferLetterSaved)['schema']['_output'];
